module.exports = __webpack_public_path__ + "img/79.fda43a9b.jpg";